import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../environments/environment";
import { PagedList } from "../model/domain/PagedList";

export interface TicketType {
  id: number;
  name: string;
}

export interface LoadType {
  id: number;
  name: string;
}

export interface OperationType {
  id: number;
  name: string;
}

export interface SettlementType {
  id: number;
  name: string;
}

export interface MarketType {
  id: number;
  name: string;
}

export interface Bank {
  id: number;
  code: string;
  name: string;
  shortName: string;
}

@Injectable({
  providedIn: "root",
})
export class DomainService {
  constructor(private http: HttpClient) {}

  GetListBank(
    code: string = null,
    name: string = null,
    page: number = null,
    pageSize: number = null
  ) {
    let url = `${environment.apiUrls.tickets}/domain/bank-list`;

    const params: any = {};
    if (code != null) {
      params.code = code;
    }

    if (name != null) {
      params.name = name;
    }

    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<Bank>>(url, {
      params,
    });
  }

  GetBank(id: number) {
    return this.http.get<Bank>(`${environment.apiUrls.tickets}/domain/${id}`);
  }

  RegisterBank(bank: Bank) {
    return this.http.post(
      `${environment.apiUrls.tickets}/domain/bank-register/`,
      bank
    );
  }

  UpdateBank(id: number, data: Bank) {
    return this.http.put(
      `${environment.apiUrls.tickets}/domain/bank-update/${id}`,
      data
    );
  }

  public ListTicketTypes(): Observable<TicketType[]> {
    return this.http.get<TicketType[]>(
      `${environment.apiUrls.tickets}/domain/types`
    );
  }

  public ListLoadTypes(): Observable<LoadType[]> {
    return this.http.get<LoadType[]>(
      `${environment.apiUrls.tickets}/domain/load-types`
    );
  }

  public ListOperationTypes(): Observable<OperationType[]> {
    return this.http.get<OperationType[]>(
      `${environment.apiUrls.tickets}/domain/operation-types`
    );
  }

  public ListSettlementTypes(): Observable<SettlementType[]> {
    return this.http.get<SettlementType[]>(
      `${environment.apiUrls.tickets}/domain/settlement-types`
    );
  }

  public ListMarketTypes(): Observable<MarketType[]> {
    return this.http.get<MarketType[]>(
      `${environment.apiUrls.tickets}/domain/market-types`
    );
  }

  public ListBanks(): Observable<Bank[]> {
    return this.http.get<Bank[]>(`${environment.apiUrls.tickets}/domain/banks`);
  }
}
